/* istanbul ignore file */

export const API_ENDPOINT =
  process.env.NODE_ENV == "production" ? "" : "https://localhost:5001";
export const API_REQUEST_TIMEOUT =
  process.env.REACT_APP_API_REQUEST_TIMEOUT || "30000";
export const GOOGLE_OAUTH_ID = process.env.REACT_APP_GOOGLE_OAUTH_ID || "";

export const NEW_ORDER_FAKE_ID = 0;
